import i18n from './i18n/fr';
import jsPDF from 'jspdf';
import * as icons from './datas/_icons_canvas';
import refDatas from './datas/_datas';

import { toFloat, toLocaleNumber } from './helpers/math_helper';
import { imgToCanvas } from './helpers/pdf_helper';
import formatters from './helpers/charts_formatter_helper';


let t = i18n[window.locale];

export function createPdf(datas) {

  const pageHeight = 297;
  const pageWidth  = 210;


//==============================================================================
//                              COMMON FUNCTIONS
//==============================================================================

  function mainTitle(doc, y, scenario) {
    doc.setFillColor(222, 0, 0);
    doc.rect(0, y, 210, 15, "F");
    doc.setFontSize(16);
    doc.setTextColor(255, 255, 255);
    doc.text(t.report.first_page.main_title, 105, y+8, null, 0, 'center');
    doc.setFontSize(10);
    doc.text(t.report.first_page.scenarii[scenario], 105, y+13, null, 0, 'center');
  }

  function title(doc, y, text) {
    doc.setFontType('normal');
    doc.setFontSize(14);
    doc.setTextColor(222, 0, 0);
    doc.text(20, y, text);
    doc.setFillColor(222, 0, 0);
    doc.rect(14, y-3, 3, 3, 'F');
  }

  function dottedText(doc, x, y, width, text) {
    const textXOffset = 5;
    doc.setFontSize(9);
    doc.setTextColor(0, 0, 0);
    doc.text(doc.splitTextToSize(text, width - textXOffset), x + textXOffset, y);
    doc.setFillColor(0, 0, 0);
    doc.circle(x+1, y-1, 0.7, 0.7, 'F');
  }

  function refText(doc, x, y, text) {
    doc.setFontType('italic');
    doc.setFontSize(5);
    doc.setTextColor(120, 120, 120);
    doc.text(text, x, y);
  }


//==============================================================================
//                              HEADER
//==============================================================================

  function header(doc, ieraLogo) {

    function background() {
      let bgImg      = document.createElement('img');
      const headerBg = document.querySelector('header.header-page');
      bgImg.src      = window.getComputedStyle(headerBg).getPropertyValue('background-image').replace(/url\("|"\)$/ig, "");
      doc.addImage(imgToCanvas(bgImg, 'jpeg'), 'JPEG', 0, 0, pageWidth, 40, undefined, 'FAST');
    }

    function text() {
      doc.addImage(icons.logoThermix(), 'PNG', 66, 11.8, 7, 7, undefined, 'FAST');
      doc.setTextColor(255);
      doc.setFontSize(18);
      doc.setFontStyle('bold');
      doc.text(75, 19, t.report.header.title);
      doc.setFontSize(12);
      doc.setFontStyle('normal');
      doc.text(65.5, 26, t.report.header.subtitle);
      doc.setFontStyle('normal');
      // line
      doc.setDrawColor(255);
      doc.line(110, 17, 159, 17);
    }

    background();
    // doc.addImage(imgToCanvas(ieraLogo, 'png'), 'PNG', 15, 5, 35, 0, undefined, 'FAST');
    text();
  }


//==============================================================================
//                                    BODY
//==============================================================================

  //----------------------------------------------------------------------------
  //  Savings
  //----------------------------------------------------------------------------

  function savingsSection(doc, offsetY, savings) {
    title(doc, offsetY, t.report.first_page.savings.title);
    let smiley = icons.happySmiley();
    if (savings.smiley === 'overjoyed')
      smiley = icons.overjoyedSmiley();
    if (savings.smiley === 'wondering')
      smiley = icons.wonderingSmiley();
    doc.addImage(smiley, 'PNG', 160, offsetY, 30, 30, undefined, 'FAST');

    offsetY += 5;
    doc.setFillColor(200, 200, 200);
    doc.rect(20, offsetY, 120, 20, 'F');
    if (['enr_more_expensive', 'only_enr'].includes(savings.conclusionId)) {
      offsetY += 6.8;
      doc.setFontSize(11);
    } else {
      offsetY += 6.4;
      doc.setFontSize(12);
    }
    doc.setTextColor(255, 255, 255);
    doc.text(doc.splitTextToSize(t.conclusion[savings.conclusionId], 114), 23, offsetY);
  }


  //----------------------------------------------------------------------------
  //  Period Total Cost
  //----------------------------------------------------------------------------

  function periodTotalCostSection(doc, offsetY, chart) {
    title(doc, offsetY, t.report.first_page.period_total_cost.title);

    const periodTotalCostCanvas = document.createElement("canvas");
    const modifiedChart = chart.getSVG({
      chart: {
        width: 960,
        height: 450,
      },
      legend: {
        itemStyle: {
          fontSize: '16px',
        },
      },
  		plotOptions: {
  			column: {
  				dataLabels: {
            style: {
              fontSize: '14px',
            },
          },
        },
      },
      xAxis: {
        labels: {
          style: {
            fontSize: '14px',
          },
          formatter: function () {
            return formatters.systemLabel(this.value, 'raw');
          },
        },
      },
      yAxis: {
        title: {
          style: {
            fontSize: '14px',
          },
        },
				stackLabels: {
          style: {
            fontSize: '13px',
          },
        },
      },
    });
    canvg(periodTotalCostCanvas, modifiedChart);
    const imgHeight = 78;
    const imgWidth = periodTotalCostCanvas.width * imgHeight / periodTotalCostCanvas.height;
    const xCenterOffset = (pageWidth - imgWidth) / 2;
    doc.addImage(periodTotalCostCanvas.toDataURL("image/png"), 'PNG', xCenterOffset, offsetY + 4, imgWidth, imgHeight, undefined, 'FAST');

    refText(doc, xCenterOffset + 4, offsetY + imgHeight + 8, t.charts.period_total_cost.ref_text);
  }


  //----------------------------------------------------------------------------
  //  Period Total Cost Evolution
  //----------------------------------------------------------------------------

  function periodCostEvolutionSection(doc, offsetY, chart) {
    title(doc, offsetY, t.report.first_page.period_cost_evolution.title);

    const modifiedChart = chart.getSVG({
      legend: {
        labelFormatter: function () {
          return formatters.systemLabel(this.name, 'raw');
        },
      },
    });
    const periodCostEvolutionCanvas = document.createElement("canvas");
    canvg(periodCostEvolutionCanvas, modifiedChart);
    const imgHeight = 78;
    const imgWidth = periodCostEvolutionCanvas.width * imgHeight / periodCostEvolutionCanvas.height;
    const xCenterOffset = (pageWidth - imgWidth) / 2;
    doc.addImage(periodCostEvolutionCanvas.toDataURL("image/png"), 'PNG', xCenterOffset, offsetY + 4, imgWidth, imgHeight, undefined, 'FAST');
    refText(doc, xCenterOffset + 4, offsetY + imgHeight + 3, t.charts.period_cost_evolution.ref_text);
  }


  //----------------------------------------------------------------------------
  //  Environmental Impact
  //----------------------------------------------------------------------------

  function environmentalImpactSection(doc, offsetY, chart) {
    title(doc, offsetY, t.report.second_page.environmental_impact.title);

    const environmentalImpactCanvas = document.createElement("canvas");
    canvg(environmentalImpactCanvas, chart.getSVG({
      xAxis: {
        labels: {
          formatter: function () {
            return formatters.systemLabel(this.value, 'raw');
          },
          style: {
            fontSize: '14px',
          },
        },
      },
      legend: {
    		align: 'right',
        itemStyle: {
          fontSize: '14px',
        },
        labelFormatter: function() {
          return formatters.environmentalImpact.legend(this, 'raw');
        },
      },
    }));
    const imgHeight = 54;
    const imgWidth = environmentalImpactCanvas.width * imgHeight / environmentalImpactCanvas.height;
    const xCenterOffset = pageWidth - imgWidth - 10;
    doc.addImage(environmentalImpactCanvas.toDataURL("image/png"), 'PNG', xCenterOffset, offsetY + 1, imgWidth, imgHeight, undefined, 'FAST');

    doc.setTextColor(30, 30, 30);
    doc.setFontSize(10);

    /* !!! UGLY !!! */
    offsetY += 8;
    t.report.second_page.environmental_impact.text.forEach((line, index) => {
      if (index == 1) offsetY += 10;
      if (index == 2) offsetY += 20;
      (line.charAt(0) == '-')
        ? dottedText(doc, 20, offsetY, xCenterOffset - 20, line.substring(1))
        : doc.text(doc.splitTextToSize(line, xCenterOffset - 20), 20, offsetY);
    });
  }


  //----------------------------------------------------------------------------
  //  Energies Price Variations
  //----------------------------------------------------------------------------

  function energiesPriceVariationsSection(doc, offsetY, chart) {
    title(doc, offsetY, t.report.second_page.price_variation.title);

    const energiesPriceVariationsCanvas = document.createElement("canvas");
    const modifiedChart = chart.getSVG({
      chart: {
        width: 460,
        height: 420,
        spacingLeft: 40,
        spacingRight: 40,
        marginRight: 40,
      },
      legend: {
        width: 440,
        labelFormatter: function() {
          const _this = this;
          const energyPriceVariation = refDatas.energy_types.find( energy => energy.identifier == _this.name).price_variation * 100;
          return formatters.energiesPriceVariations.legend(this, energyPriceVariation, 'raw');
        },
      },
      yAxis: [
        {
      		title: {
      			text: t.charts.energies_yearly_price_variations.yAxis.title,
      		},
          max: chart.yAxis[0].max,
          endOnTick: false,
      	}, {
          title: null,
          linkedTo: 0,
          opposite: true,
        },
      ],
    });
    canvg(energiesPriceVariationsCanvas, modifiedChart);
    const imgHeight = 60;
    const imgWidth = energiesPriceVariationsCanvas.width * imgHeight / energiesPriceVariationsCanvas.height;
    doc.addImage(energiesPriceVariationsCanvas.toDataURL("image/png"), 'PNG', 15, offsetY + 1, imgWidth, imgHeight, undefined, 'FAST');

    doc.setTextColor(30, 30, 30);
    doc.setFontSize(9);
    doc.text(doc.splitTextToSize(t.report.second_page.price_variation.text[0], 110), 90, offsetY + 10);
    doc.text(doc.splitTextToSize(t.report.second_page.price_variation.text[1], 110), 90, offsetY + 23);
    doc.text(doc.splitTextToSize(t.report.second_page.price_variation.text[2], 110), 90, offsetY + 44);
  }


  //----------------------------------------------------------------------------
  //  Solutions Resume Spreadsheet
  //----------------------------------------------------------------------------

  function solutionsResumeSection(doc, startX, startY, lineHeight, gap, scenarioResults) {
    const tableOffsetY   = startY + 4;
    const txtOffsetXCorr = 1;

    function systemTypeColumn(width, systems) {
      const heatingHeight  = lineHeight * systems[0].length;
      const hotWaterHeight = lineHeight * systems[1].length;
      const solarHeight    = lineHeight * systems[2].length;
      const resumeHeight   = lineHeight * systems[3].length;

      doc.setDrawColor(200, 200, 200);
      doc.setTextColor(30, 30, 30);
      doc.setFontSize(7);

      let offsetY = tableOffsetY + lineHeight;
      doc.rect(startX, offsetY, width, heatingHeight);
      doc.text("CHAUFFAGE", startX + width / 2, offsetY + lineHeight * 6, null, 0, 'center');

      offsetY += heatingHeight + gap;
      doc.rect(startX, offsetY, width, hotWaterHeight);
      doc.text("EAU CHAUDE", startX + width / 2, offsetY + lineHeight * 5.1, null, 0, 'center');
      doc.text("SANITAIRE", startX + width / 2, offsetY + lineHeight * 6.1, null, 0, 'center');

      offsetY += hotWaterHeight + gap;
      doc.rect(startX, offsetY, width, solarHeight);
      doc.text("SOLAIRE", startX + width / 2, offsetY + lineHeight * 1.2, null, 0, 'center');
      doc.text("THERMIQUE", startX + width / 2, offsetY + lineHeight * 2.2, null, 0, 'center');

      offsetY += solarHeight + gap;
      doc.setTextColor(255, 255, 255);
      doc.setDrawColor(255, 255, 255);
      doc.setFillColor(247, 163, 93);
      doc.rect(startX, offsetY, width, resumeHeight, 'FD');
      doc.text("BILAN", startX + width / 2, offsetY + lineHeight * 3.1, null, 0, 'center');
      doc.text("GLOBAL", startX + width / 2, offsetY + lineHeight * 4.1, null, 0, 'center');
    }

    function headerColumn(offsetX, width, title) {
      doc.setFontType('bold');
      doc.setFontSize(7);
      doc.setTextColor(30, 30, 30);
      doc.text(title, offsetX + width / 2, tableOffsetY + lineHeight - txtOffsetXCorr, null, 0, 'center');

      doc.setDrawColor(200, 200, 200);
      doc.rect(offsetX, tableOffsetY, width, lineHeight, 'S');
    }

    function bodyColumn(offsetX, width, systems, fontWeights, label=false) {
      doc.setFontType('normal');
      doc.setFontSize(6);

      let offsetY = tableOffsetY + lineHeight;
      systems.forEach( (systemDatum, i) => {
        const systemHeight = lineHeight * systemDatum.length;
        if (i == systems.length - 1) {
          doc.setTextColor(255, 255, 255);
          doc.setFillColor(247, 163, 93);
          doc.rect(offsetX, offsetY, width, systemHeight, 'F');
        } else {
          doc.setTextColor(30, 30, 30);
        }
        systemDatum.forEach( (systemData, j) => {
          const lineOffsetY = offsetY + lineHeight * (j + 1) - txtOffsetXCorr;
          if (i < systems.length - 1 && j % 2 != 0) {
            doc.setFillColor(240, 240, 240);
            doc.rect(offsetX, lineOffsetY - 3.15, width, lineHeight, 'F');
          }
          doc.setFontType(fontWeights[i][j])
          if (label == true) {
            doc.text(systemData.title.toString(), offsetX + 1, lineOffsetY);
            doc.text(systemData.units.toString(), offsetX + labelsColumnWidth - 1, lineOffsetY, null, 0, 'right');
          } else {
            doc.text(toLocaleNumber(systemData), offsetX + width - 1, lineOffsetY, null, 0, 'right');
          }
        });
        (i < systems.length - 1)
          ? doc.setDrawColor(200, 200, 200)
          : doc.setDrawColor(255, 255, 255);
        doc.rect(offsetX, offsetY, width, systemHeight, 'S');
        if (label == true)
          doc.rect(offsetX + labelsColumnWidth - unitsColumnWidth, offsetY, unitsColumnWidth, systemHeight, 'S');

        if (i < systems.length - 1) offsetY += systemHeight + gap;
      });
    }

    const systemColumnWidth   = 18;
    const labelsColumnWidth   = 58;
    const unitsColumnWidth    = 11;
    const nbSolutions         = scenarioResults.values.length;
    const solutionColumnWidth = (pageWidth - startX * 2 - systemColumnWidth - labelsColumnWidth) / nbSolutions;
    const tt                  = t.report.second_page.solutions_resume;
    // Build labels for each sections
    const labels = [
      [ tt.heating_system.solution,
        tt.heating_system.investment,
        tt.heating_system.needs,
        tt.heating_system.yearly_solar_prod,
        tt.heating_system.yearly_energy_product,
        tt.heating_system.efficiency,
        tt.heating_system.secondary_efficiency,
        tt.heating_system.yearly_final_energy_consumption,
        tt.heating_system.energy_price,
        tt.heating_system.energy_price_variation,
        tt.heating_system.avg_yearly_energy_cost,
      ],
      [ tt.hot_water_system.solution,
        tt.hot_water_system.investment,
        tt.hot_water_system.needs,
        tt.hot_water_system.yearly_solar_prod,
        tt.hot_water_system.yearly_energy_product,
        tt.hot_water_system.efficiency,
        tt.hot_water_system.yearly_final_energy_consumption,
        tt.hot_water_system.energy_price,
        tt.hot_water_system.energy_price_variation,
        tt.hot_water_system.avg_yearly_energy_cost,
      ],
      [ tt.solar_system.solution,
        tt.solar_system.solar_area,
        tt.solar_system.investment,
      ],
      [ tt.total.yearly_energy_total_cost,
        tt.total.enr_prod_ratio,
        tt.total.yearly_final_energy_consumption,
        tt.total.primary_energy_ratio_consumption,
        tt.total.yearly_green_house_gaz,
        tt.total.yearly_ghg_by_car,
        tt.total.yearly_wood_volume,
      ],
    ];
    const fontWeights = labels.map(function(system) {
      return system.map(systemLabels => systemLabels.font_weight);
    });

    title(doc, startY, t.report.second_page.solutions_resume.title);
    systemTypeColumn(systemColumnWidth, labels);
    bodyColumn(startX+systemColumnWidth, labelsColumnWidth, labels, fontWeights, true);

    for (let i = 0; i < nbSolutions; i++) {
      const offsetX                  = startX + systemColumnWidth + labelsColumnWidth + solutionColumnWidth*i;
      const heatingSystemId          = scenarioResults.computedDatas[i].heatingSystem.id;
      const hotWaterSystemId         = scenarioResults.computedDatas[i].hotWaterSystem.id;
      let hotWaterLabel = '';
      if (hotWaterSystemId == 0 || hotWaterSystemId == heatingSystemId) {
        hotWaterLabel = t.datas.hot_water_systems[scenarioResults.computedDatas[i].heatingSystem.datas.identifier].short;
      } else if (hotWaterSystemId != -1) {
        hotWaterLabel = t.datas.hot_water_systems[scenarioResults.computedDatas[i].hotWaterSystem.datas.identifier].short;
      };
      const solarSystem              = scenarioResults.computedDatas[i].solarSystem.datas;
      const solarPanelSurface        = scenarioResults.values[i].solar.panelSurface;
      const solarEstimatedInvestment = scenarioResults.values[i].solar.estimatedInvestment;

      // Build data for each sections
      const solutionDatas = [
        [ t.datas.heating_systems[scenarioResults.computedDatas[i].heatingSystem.datas.identifier].short, // heating_system.solution
          scenarioResults.computedDatas[i].heatingSystem.estimatedInvestment, // heating_system.investment
          scenarioResults.values[i].heating.needs, // heating_system.needs
          scenarioResults.computedDatas[i].solarSystem.yearlySolarProd.heating, // heating_system.yearly_solar_prod
          scenarioResults.computedDatas[i].heatingSystem.yearlyEnergyProduct, // heating_system.yearly_energy_product
          parseInt(scenarioResults.computedDatas[i].heatingSystem.efficiency * 100) + ' %', // heating_system.efficiency
          parseInt(scenarioResults.computedDatas[i].heatingSystem.datas.secondary_efficiency * 100) + ' %', // heating_system.secondary_efficiency
          parseInt(scenarioResults.computedDatas[i].heatingSystem.yearlyFinalEnergyConsumption), // heating_system.yearly_final_energy_consumption
          toFloat(scenarioResults.computedDatas[i].heatingSystem.energyPrice, 2), // heating_system.energy_price
          toFloat(scenarioResults.computedDatas[i].heatingSystem.energyPriceVariation * 100, 2) + ' %', // heating_system.energy_price_variation
          parseInt(scenarioResults.computedDatas[i].heatingSystem.avgYearlyEnergyCost), // heating_system.avg_yearly_energy_cost
        ],
        [ hotWaterLabel, //hot_water_system.solution
          (hotWaterSystemId == -1) ? '' : scenarioResults.computedDatas[i].hotWaterSystem.estimatedInvestment, // hot_water_system.investment
          (hotWaterSystemId == -1) ? '' : scenarioResults.values[i].hotWater.needs,  // hot_water_system.needs
          (hotWaterSystemId == -1) ? '' : scenarioResults.computedDatas[i].solarSystem.yearlySolarProd.hotWater, // hot_water_system.yearly_solar_prod
          (hotWaterSystemId == -1) ? '' : scenarioResults.computedDatas[i].hotWaterSystem.yearlyEnergyProduct,// hot_water_system.yearly_energy_product
          (hotWaterSystemId == -1) ? '' : parseInt(scenarioResults.computedDatas[i].hotWaterSystem.efficiency * 100) + ' %', // hot_water_system.efficiency
          (hotWaterSystemId == -1) ? '' : parseInt(scenarioResults.computedDatas[i].hotWaterSystem.yearlyFinalEnergyConsumption), // hot_water_system.yearly_final_energy_consumption
          (hotWaterSystemId == -1) ? '' : toFloat(scenarioResults.computedDatas[i].hotWaterSystem.energyPrice, 2), // hot_water_system.energy_price
          (hotWaterSystemId == -1) ? '' : toFloat(scenarioResults.computedDatas[i].hotWaterSystem.energyPriceVariation * 100, 2) + ' %', // hot_water_system.energy_price_variation
          (hotWaterSystemId == -1) ? '' : parseInt(scenarioResults.computedDatas[i].hotWaterSystem.avgYearlyEnergyCost), // hot_water_system.avg_yearly_energy_cost
        ],
        [ (solarSystem == '') ? '' : t.datas.solar_systems[solarSystem.identifier].short, // solar_system.solution
          (solarPanelSurface == 0) ? '' : solarPanelSurface, // solar_system.solar_area
          (solarEstimatedInvestment == 0) ? '' : solarEstimatedInvestment, // solar_system.investment
        ],
        [ parseInt(scenarioResults.periodTotalCost.computedDatas[i].yearlyTotalCost), // total.yearly_energy_total_cost
          parseInt(scenarioResults.periodTotalCost.computedDatas[i].enrProdRatio * 100) + '%', // total.enr_prod_ratio
          parseInt(scenarioResults.periodTotalCost.computedDatas[i].yearlyFinalEnergyConsumption), // total.yearly_final_energy_consumption
          parseInt(scenarioResults.environmentalImpact.computedDatas[i].yearlyPrimaryEnergy), // total.primary_energy_ratio_consumption
          parseInt(scenarioResults.environmentalImpact.computedDatas[i].yearlyGreenHouseGaz), // total.ghg_ratio_by_car
          parseInt(scenarioResults.environmentalImpact.computedDatas[i].yearlyGhgByCar), // total.ghg_ratio
          parseInt(scenarioResults.periodTotalCost.computedDatas[i].yearlyWoodVolume), // total.yearly_wood_volume
        ],
      ];
      headerColumn(offsetX, solutionColumnWidth, t.report.second_page.solutions_resume.solution_header + ' ' + (i + 1));
      bodyColumn(offsetX, solutionColumnWidth, solutionDatas, fontWeights);
    }

    const totalNbLines = [].concat.apply([], labels).length + 1;
    refText(doc, startX + systemColumnWidth + 1, tableOffsetY + totalNbLines * lineHeight + labels.length * gap + 1, tt.simulation_period);
  }


//==============================================================================
//                                    FOOTER
//==============================================================================

  function footer(doc, partnerLogos) {
    const height = 19;
    const y      = pageHeight - height;
    const width  = pageWidth;

    function background() {
      doc.setFillColor(246, 246, 246);
      doc.rect(0, y, width, height, 'F');
    }

    function logo(partnerId, x, y, width, height) {
      doc.addImage(imgToCanvas(partnerLogos[partnerId].querySelector('img'), 'png'), 'PNG', x, y, width, height, undefined, 'FAST');
      doc.link(x, y, x+width, y+height, {
        url: partnerLogos[partnerId].getAttribute('href'),
      });
    }

    function thermixLink() {
      doc.setTextColor(228, 35, 48);
      doc.setFontSize(10);
      doc.text(t.report.thermix_href, 105, y+10, null, 0, 'center');
    }

    function createdAt() {
      doc.setTextColor(128);
      doc.setFontSize(6);
      doc.text(167, 287, t.report.footer.at + (new Date()).toLocaleDateString());
    }

    background();
    logo('hespul', 10, y+5, 9, 9);
    logo('auvergneRhoneAlpes', 21, y+5, 19, 9);
    logo('ademe', 42, y+4, 10, 11);
    logo('europe', 56, y+6, 10, 7);
    thermixLink()
    createdAt();
  }


//==============================================================================
//                               BUILD REPORT
//==============================================================================

  let doc = new jsPDF('p', 'mm', 'a4', true);


  //----------------------------------------------------------------------------
  //  FIRST PAGE
  //----------------------------------------------------------------------------

  header(doc, datas.partnerLogos['iera']);
  mainTitle(doc, 40.5, datas.scenario);
  savingsSection(doc, 65, datas.scenarioResults.savings);
  periodTotalCostSection(doc, 100, datas.charts.periodTotalCost);
  periodCostEvolutionSection(doc, 194, datas.charts.periodCostEvolution);
  footer(doc, datas.partnerLogos);


  //----------------------------------------------------------------------------
  //  SECOND PAGE
  //----------------------------------------------------------------------------

  doc.addPage();
  doc.setPage(2);
  environmentalImpactSection(doc, 8, datas.charts.environmentalImpact);

  energiesPriceVariationsSection(doc, 65, datas.charts.energiesPriceVariations);
  solutionsResumeSection(doc, 10, 130, 4.3, 1, datas.scenarioResults);
  footer(doc, datas.partnerLogos);

  doc.save('thermix_report.pdf');
}



// WEBPACK FOOTER //
// ./assets/javascripts/pdf_report.js